module.exports = __webpack_public_path__ + "static/media/google_auth.96980789.png";